import { HERO_IMAGE } from "../data/content";
import { ArrowDown, ArrowUpRight } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden bg-stone-100"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Elegant living room with bespoke wallpaper and aesthetic furniture"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/85 to-white/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-white/70 via-transparent to-white/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[90rem] mx-auto px-6 md:px-12 pt-40 pb-32 min-h-[100svh] flex flex-col justify-center">
        <div className="max-w-4xl">
          <p
            data-testid="hero-eyebrow"
            className="overline mb-8 flex items-center gap-3"
          >
            Bespoke Surface Solutions
          </p>

          <h1
            data-testid="hero-headline"
            className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-stone-900"
          >
            Designed for your
            <br />
            <em className="italic font-normal text-[#4A6076]">Space</em>
            <span className="text-stone-800"> and no one else&rsquo;s.</span>
            <sup className="align-super text-[0.4em] text-[#4A6076] ml-1 font-medium tracking-normal">™</sup>
          </h1>

          <p
            data-testid="hero-subheading"
            className="mt-10 max-w-2xl text-lg md:text-xl leading-relaxed text-stone-700 font-light"
          >
            Your home deserves more than a catalogue. Every wallpaper, surface,
            and architectural finish is thoughtfully designed from scratch to
            reflect your personality, lifestyle, and emotions. One home. One
            design. Never replicated.
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-4">
            <a
              href="#services"
              data-testid="hero-cta-primary"
              className="btn-primary"
            >
              Explore Services <ArrowUpRight size={16} strokeWidth={1.5} />
            </a>
            <a
              href="#contact"
              data-testid="hero-cta-secondary"
              className="btn-outline"
            >
              Start Your Project
            </a>
          </div>
        </div>

        {/* Bottom meta line */}
        <div className="absolute bottom-10 left-6 md:left-12 right-6 md:right-12 flex items-end justify-between text-stone-700">
          <a
            href="#about"
            data-testid="hero-scroll-indicator"
            className="flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase hover:text-stone-900 transition-colors"
          >
            <ArrowDown size={16} strokeWidth={1.5} className="animate-float-slow" />
            Scroll to explore
          </a>
          <div className="hidden md:flex items-center gap-8 text-[11px] tracking-[0.3em] uppercase">
            <span>Residential</span>
            <span>Hospitality</span>
            <span>Healthcare</span>
            <span>Retail</span>
          </div>
        </div>
      </div>
    </section>
  );
}
